import type { LearningFieldMeasurement } from '../shared/desktop-api';
import { measuredLearningAttempts } from './learning-attempts';

export function LearningTrialSummary({
  evidenceKey,
  attempts,
  tables = false,
  training = false,
}: {
  evidenceKey: string;
  attempts: LearningFieldMeasurement['attempts'];
  tables?: boolean;
  training?: boolean;
}) {
  const trials = measuredLearningAttempts(evidenceKey, attempts ?? []);
  if (!trials.length) return null;
  const best = trials.reduce((best, trial) => (trial.right > best.right ? trial : best));
  return (
    <small>
      {trials.length} {trials.length === 1 ? 'approach' : 'approaches'} checked · best result:{' '}
      <b>
        {best.right}/{best.total}
      </b>{' '}
      {tables ? 'complete tables' : 'field values'} correct
      {training ? ' in training' : ' in this comparison'}. This is not a final accuracy score.
    </small>
  );
}
